/* eslint-disable max-len */

export default function Biometrics(props) {
  let content = '';
  if (!props || !props.data) {
    return content;
  }
  if (props.column.field === 'risk') {
    let tflag = '';
    let oflag = '';
    let hflag = '';
    // const bpflag = '';
    let hrflag = '';
    let hrvflag = '';
    let rrflag = '';
    if (props.data.temperature && props.data.temperature.alert && props.data.temperature.alert !== '') {
      tflag = '<font color="red">&#10003;</font>';
    }
    if (props.data.heartrate && props.data.heartrate.alert && props.data.heartrate.alert !== '') {
      hrflag = '<font color="red">&#10003;</font>';
    }
    /*
    if (props.data.bloodpressure && props.data.bloodpressure.alert && props.data.bloodpressure.alert !== '') {
      bpflag = '<font color="red">&#10003;</font>';
    }
      */
    if (props.data.oxygen && props.data.oxygen.alert && props.data.oxygen.alert !== '') {
      oflag = '<font color="red">&#10003;</font>';
    }
    if (props.data.hydration && props.data.hydration.alert && props.data.hydration.alert !== '') {
      hflag = '<font color="red">&#10003;</font>';
    }
    if (props.data.respiratory && props.data.respiratory.alert && props.data.respiratory.alert !== '') {
      rrflag = '<font color="red">&#10003;</font>';
    }
    if (props.data.hrv && props.data.hrv.alert && props.data.hrv.alert !== '') {
      hrvflag = '<font color="red">&#10003;</font>';
    }
    // const temp = props.data.temperature.reading;
    // const hydration = props.data.hydration.reading;
    let set = false;
    let riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th bgcolor="cyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
    if (props.data.risk < 0) {
      // props.cell.classList.add('riskbelow-30');
      props.cell.classList.add('rowcellblue');
      riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th bgcolor="cyan"><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
      set = true;
    } else if (props.data.risk === '' || props.data.risk < 25) {
      // props.cell.classList.add('riskbelow-30');
      props.cell.classList.add('rowcellgrn');
      riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font><th><th  bgcolor="cyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
      set = true;
    } else if (props.data.risk < 50) {
      // props.cell.classList.add('riskbelow-80');
      props.cell.classList.add('rowcellylw');
      riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font><th><th bgcolor="cyan"><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
      set = true;
    } else if (props.data.risk < 80) {
      props.cell.classList.add('rowcellorn');
      riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font><th><th bgcolor="cyan"><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
      set = true;
    } else {
      // props.cell.classList.add('riskabove-80');
      props.cell.classList.add('rowcellred');
      riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font><th><th bgcolor="cyan"><font color="red">SEVERE</font></th></tr></tbody></table>';
      set = true;
    }
    // Universal AQI
    // Code: uaqi
    // Pollutants: "co", "no2", "o3", "pm10", "pm25", "so2"
    // 100 - 80 Excellent air quality
    // 79 - 60 Good air quality
    // 59 - 40 Moderate air quality
    // 39 - 20 Low air quality
    // 19 - 1 Poor air quality
    // 0 Poor air quality

    if (!set && props.data.environment < 20) {
      props.cell.classList.add('aqi20');
    } else if (!set && props.data.environment < 40) {
      props.cell.classList.add('aqi40');
    } else if (!set && props.data.environment < 60) {
      props.cell.classList.add('aqi60');
    } else if (!set && props.data.environment < 80) {
      props.cell.classList.add('aqi80');
    } else if (!set) {
      props.cell.classList.add('aqi100');
    }
    let bhrv = '';
    let bhr = '';
    let btemp = '';
    let boxy = '';
    let bhyd = '';
    let brr = '';
    if (props.data.baseline && props.data.baseline.hrv && props.data.baseline.hrv.nominal) {
      bhrv = props.data.baseline.hrv.nominal.toFixed(1);
    }
    if (props.data.baseline && props.data.baseline.heartrate && props.data.baseline.heartrate.nominal) {
      bhr = props.data.baseline.heartrate.nominal.toFixed(1);
    }
    if (props.data.baseline && props.data.baseline.temperature && props.data.baseline.temperature.nominal) {
      btemp = props.data.baseline.temperature.nominal.toFixed(1);
    }
    if (props.data.baseline && props.data.baseline.oxygen && props.data.baseline.oxygen.nominal) {
      boxy = props.data.baseline.oxygen.nominal.toFixed(1);
    }
    if (props.data.baseline && props.data.baseline.hydration && props.data.baseline.hydration.nominal) {
      bhyd = props.data.baseline.hydration.nominal.toFixed(1);
    }
    if (props.data.baseline && props.data.baseline.respiratory && props.data.baseline.respiratory.nominal) {
      brr = props.data.baseline.respiratory.nominal.toFixed(1);
    }
    content = `<h1 style="text-align: center;">${props.data.name ? props.data.name.toUpperCase() : ''}: BIOMETRICS</h1><table class="biotable"><tbody><tr><th colspan="2">${riskLevel}</th><tr><td class="biometricsgrn"><sup class="supsm">hr</sup>💖${props.data.heartrate && props.data.heartrate.reading ? props.data.heartrate.reading : ''}<sub class="supsm">bpm</sub>${hrflag}<sup class="supsm">(${bhr})</sup></td><td class="biometricsltgrn">
      <sup class="supsm">hrv</sup>💗${props.data.hrv && props.data.hrv.reading ? props.data.hrv.reading : ''}<sub class="supsm">ms</sub>${hrvflag}<sup class="supsm">(${bhrv})</sup></td></tr><tr><td class="biometricsltblue"><sup class="supsm">oxy</sup>O<sub  class="supsm">2</sub>${props.data.oxygen && props.data.oxygen.reading ? props.data.oxygen.reading : ''}<sub class="supsm">%</sub>${oflag}<sup class="supsm">(${boxy})</sup></td><td class="biometricsylw"><sup class="supsm">temp</sup><span class="rotate-char">🌡</span>${props.data.temperature && props.data.temperature.reading ? props.data.temperature.reading : ''}<sub class="supsm">°F</sub>${tflag}<sup class="supsm">(${btemp})</sup></td></tr><tr><td class="biometricsblue"><sup class="supsm">hyd</sup>💦${props.data.hydration && props.data.hydration.reading ? props.data.hydration.reading : ''}<sub class="supsm">%</sub>${hflag}<sup class="supsm">(${bhyd})</sup></td><td class="biometricsblue"><sup class="supsm">rr</sup>🫁${props.data.respiratory && props.data.respiratory.reading ? props.data.respiratory.reading : ''}<sub class="supsm">b/m</sub>${rrflag}<sup class="supsm">(${brr})</sup></td></tr></tbody></table>`;
  }
  return content;
}
